import { computed } from 'vue'

const ROLES = {
  ADMIN: 'admin',
  MANAGE: 'manage',
  DASHBOARD_MANAGER: 'dashboard_manager',
  DASHBOARD_CREATOR: 'dashboard_creator',
  INDICATOR_RESPONSIBLE: 'indicator_responsible',
}

Object.freeze(ROLES)

export function useAbilities() {
  const userRoles = computed(() => window.gon?.user?.roles ?? [])

  const hasRole = (...checkRoles) => checkRoles.some(role => userRoles.value.includes(role))

  const isAdmin = computed(() => hasRole(ROLES.ADMIN))

  return {
    canViewManage:      computed(() => isAdmin.value || hasRole(ROLES.DASHBOARD_CREATOR, ROLES.DASHBOARD_MANAGER)),
    canViewComponents:  computed(() => isAdmin.value || hasRole(ROLES.MANAGE, ROLES.DASHBOARD_MANAGER)),
    canViewStatistics:  computed(() => isAdmin.value || hasRole(ROLES.INDICATOR_RESPONSIBLE, ROLES.DASHBOARD_MANAGER)),
    canViewPermissions: computed(() => hasRole(ROLES.ADMIN)),

    canAddDashboard:    computed(() => isAdmin.value || hasRole(ROLES.DASHBOARD_CREATOR)),

    hasRole,
  }
}